<template>
	<div class="w1200 orderFood">
		<div class="flex wrap" v-if="fen_list.length > 0">
			<template v-for="(item,index) in fen_list">
				<div class="flex flex-wrap align-center benben-flex-layout pointer orderFood_1" @click="dancan(item)">
					<img class="orderFood_2" :src="item.pc_image" alt="" srcset="">
					<div class="">
						<div class="orderFood_3">{{item.name}}</div>
						<div class="orderFood_4">{{item.describe}}</div>
					</div>
					<img class="orderFood_5" src="https://api.ezlunch.club/pc/image/20.png" alt="" srcset="">
				</div>
			</template>
			<!-- <div class="flex flex-wrap align-center benben-flex-layout pointer orderFood_1" @click="dancan(1)">
				<img class="orderFood_2" src="https://api.ezlunch.club/pc/image/18.png" alt="" srcset="">
				<div class="">
					<div class="orderFood_3">两菜点餐</div>
					<div class="orderFood_4">Order two dishes</div>
				</div>
				<img class="orderFood_5" src="https://api.ezlunch.club/pc/image/20.png" alt="" srcset="">
			</div>
			<div class="flex flex-wrap align-center benben-flex-layout pointer orderFood_1s" @click="dancan(2)">
				<img class="orderFood_2" src="https://api.ezlunch.club/pc/image/19.png" alt="" srcset="">
				<div class="">
					<div class="orderFood_3">三菜点餐</div>
					<div class="orderFood_4">Order three dishes</div>
				</div>
				<img class="orderFood_5" src="https://api.ezlunch.club/pc/image/20.png" alt="" srcset="">
			</div> -->
		</div>
		<div class="orderFood_6" v-if="img_list.length > 0">
			<el-carousel trigger="click" height="700px">
				<template v-for="(item,index) in img_list">
					<el-carousel-item>
					    <img class="orderFood_7" :src="item.thumb" alt="" srcset="">
					</el-carousel-item>
				</template>
			    
			</el-carousel>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				fen_list:[],
				img_list:[],
			}
		},
		created() {
			if(window.sessionStorage.getItem('token')){
				this.post68e6215c5a333()
				this.post641e624160dd0()
			}else{
				this.$router.push({
					name: 'login',
				});
			}
			
		},

		methods: {
			gengxin(){
				this.post68e6215c5a333()
				this.post641e624160dd0()
			},
			// 轮播图
			post641e624160dd0(){
				this.$api.post(this.$apiUrls.post641e624160dd0,{type:5}).then((res) => {
					if(res.code == 1){
						this.img_list = res.data
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			// 餐类型
			post68e6215c5a333(){
				this.$api.post(this.$apiUrls.post68e6215c5a333).then((res) => {
					if(res.code == 1){
						this.fen_list = res.data
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			dancan(item){
				
				window.sessionStorage.setItem('can_type', JSON.stringify({aid:item.aid,name:item.name}));
				this.$router.push({
					name: 'choiceFood',
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		.el-carousel__button{
			width: 10px;
			height: 10px;
			border-radius: 10px;
		}
		.is-active{
			.el-carousel__button{
				width: 34px;
				height: 10px;
				border-radius: 10px;
			}
		}
	}
	.orderFood{
		margin-top: 20px;
	}
	.orderFood_1{
		width: 588px;
		height: 210px;
		background: #FFF4E3;
		border-radius: 16px;
		padding: 0 40px;
		box-sizing: border-box;
		margin: 0 24px 24px 0;
	}
	.orderFood_1:nth-child(2n){
		background: #FFF1F7;
		margin-right: 0;
	}
	.orderFood_1s{
		width: 588px;
		height: 210px;
		background: #FFF1F7;
		border-radius: 16px;
		padding: 0 40px;
		box-sizing: border-box;
	}
	.orderFood_2{
		width: 197px;
		height: 130px;
		margin-right: 12px;
	}
	.orderFood_3{
		font-weight: bold;
		font-size: 26px;
		color: #1A1A1A;
	}
	.orderFood_4{
		font-weight: 400;
		font-size: 20px;
		color: #666666;
	}
	.orderFood_5{
		width: 32px;
		height: 32px;
		margin: 0 0 0 auto;
	}
	.orderFood_6{
		margin: 0px 0 32px 0;
	}
	.orderFood_7{
		width: 100%;
		height: 700px;
	}
</style>